import React, { useMemo } from 'react';
import { useSimpleToggle } from '../../../../hooks/use-simple-toggle';
import { HeadersFactory, ProviderTable, createColumnData } from '../components';
import { useProvidersGridContext } from '../providers-grid-context';
import { vendorColumns } from './vendor-columns';
import VendorFactory from './vendor-factory';
import { VendorListHeader } from './vendor-list-header';

const additionalColumns = [
  {
    place: 1,
    column: vendorColumns.EMAIL,
  },
];

const createVendorColumn = (vendor, key) => {
  return {
    key: vendor[key],
    ...createColumnData(vendor),
    [vendorColumns.EMAIL]: vendor,
  };
};

const createTableRows = (vendors, key) => {
  return vendors.map((vendor) => createVendorColumn(vendor, key));
};

export const VendorList = () => {
  const { vendors } = useProvidersGridContext();

  const [showInactive, toggleInactive] = useSimpleToggle();

  const pendingInvitations = useMemo(() => createTableRows(vendors.pendingInvitations, 'externalInviteId'), [vendors.pendingInvitations]);

  const activeProviders = useMemo(() => createTableRows(vendors.activeProviders, 'externalClientConnectionId'), [vendors.activeProviders]);

  const data = useMemo(() => {
    let inactiveProviders = [];

    if (showInactive) {
      inactiveProviders = createTableRows(
        vendors.list.filter((vendor) => !vendor.active),
        'externalClientConnectionId',
      );
    }

    return pendingInvitations.concat(activeProviders).concat(inactiveProviders);
  }, [activeProviders, pendingInvitations, showInactive, vendors.list]);

  const componentFactory = useMemo(
    () => ({
      factory: VendorFactory,
      props: {},
    }),
    [],
  );

  return (
    <>
      <VendorListHeader showInactive={showInactive} toggleInactive={toggleInactive} />
      <ProviderTable
        additionalColumns={additionalColumns}
        componentFactory={componentFactory}
        data={data}
        headersFactory={HeadersFactory}
      />
    </>
  );
};
